<template>
	<AppHeader
		:logo="logo"
		:headerButton2="headerButton2"
		hideBtn1
	/>

	<div class="flex-grow-1">
		<UiElement class="d-flex flex-column h-100 pb-0" :settings="appearance.body.settings">
			<div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
				<UiText :settings="heading1" class="text-center" :content="translations?.cancelOrderTitle || '{cancelOrderTitle}'">
				</UiText>

				<UiText :settings="heading2" class="text-center" :content="translations?.payDialogCancellation || '{payDialogCancellation}'" />

				<div class="d-flex align-items-center gap-5">
					<UiButton
						:settings="button1"
						@touchstart="cancelOrder"
						:content="translations?.yes || '{yes}'"
					/>

					<UiButton
						:settings="button2"
						@touchstart="goBack"
						:content="translations?.no || '{no}'"
					>
					</UiButton>
				</div>
			</div>
		</UiElement>
	</div>
</template>

<script setup>
	import { computed, onMounted } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useThemeStore } from '@/stores/useThemeStore';
	import { useOrderStore } from '@/stores/useOrderStore';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useRouter } from 'vue-router';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import AppHeader from '@/components/AppHeader.vue';
	import { useIdleStore } from '@/stores/useIdleStore';

	const router = useRouter();
	const { resetTimer, clearTimers } = useIdleStore();

	const themeStore = useThemeStore();
	const orderStore = useOrderStore();
	const idleStore = useIdleStore();
	const translationsStore = useTranslationsStore();

	const { translations } = storeToRefs(translationsStore);
	const { theme } = storeToRefs(themeStore);

	const page = computed(() => theme.value.pages.cancel);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const heading2 = useInheritedSettings(computed(() => elements.value?.heading2));
	const button1 = useInheritedSettings(computed(() => elements.value?.button1));
	const button2 = useInheritedSettings(computed(() => elements.value?.button2));
	const logo = useInheritedSettings(computed(() => elements.value?.logo));
	const headerButton2 = useInheritedSettings(computed(() => elements.value?.headerButton2));

	function cancelOrder() {
		idleStore.cancelUsage();
		orderStore.clearCart();
	}

	function goBack() {
		resetTimer();
		router.go(-1);
	}

	onMounted(() => {
		setTimeout(() => {
			const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
			events.forEach(event => window.removeEventListener(event, resetTimer));
			clearTimers();
		}, 0);
	});
</script>